import { ref } from 'vue'

// Generic queue of "committed" student snapshots for a multi-student invite.
// Field shape is up to the caller — this just manages the list.
export function useMultiStudentQueue() {
  const queued = ref([])

  function addStudent(snapshot) {
    queued.value.push(snapshot)
  }

  function removeStudent(index) {
    queued.value.splice(index, 1)
  }

  function clearQueue() {
    queued.value = []
  }

  return { queued, addStudent, removeStudent, clearQueue }
}
